(() => {
  'use strict';
  const seen=new WeakSet(),colors=new Map();
  function dominantColor(image){
    const canvas=document.createElement('canvas');canvas.width=48;canvas.height=48;
    const context=canvas.getContext('2d',{willReadFrequently:true});if(!context)throw Error('Canvas unavailable');
    context.drawImage(image,0,0,48,48);const pixels=context.getImageData(0,0,48,48).data,buckets=new Map();
    for(let y=4;y<44;y++)for(let x=4;x<44;x++){
      const offset=(y*48+x)*4,r=pixels[offset],g=pixels[offset+1],b=pixels[offset+2];if(pixels[offset+3]<128)continue;
      const max=Math.max(r,g,b),min=Math.min(r,g,b),saturation=max?(max-min)/max:0;
      if(max<25||(min>230&&saturation<0.12))continue;
      const key=[r,g,b].map(n=>Math.floor(n/32)).join('-'),bucket=buckets.get(key)||{r:0,g:0,b:0,count:0,weight:0};
      const center=1-0.3*(Math.abs(x-24)+Math.abs(y-24))/40;
      bucket.r+=r;bucket.g+=g;bucket.b+=b;bucket.count++;bucket.weight+=(0.04+saturation*saturation)*center;buckets.set(key,bucket);
    }
    const chosen=[...buckets.values()].sort((a,b)=>b.weight-a.weight)[0];
    if(!chosen)return '#eeeae2';
    return '#'+['r','g','b'].map(k=>Math.round(chosen[k]/chosen.count).toString(16).padStart(2,'0')).join('');
  }
  function sample(source){
    const url=new URL(source,location.href).href;
    if(!colors.has(url))colors.set(url,new Promise((resolve,reject)=>{
      const key='ipopu-swatch-v1:'+url;
      try{const value=sessionStorage.getItem(key);if(/^#[0-9a-f]{6}$/i.test(value||'')){resolve(value);return}}catch{}
      const image=new Image();image.crossOrigin='anonymous';let timer=setTimeout(()=>{image.onload=image.onerror=null;reject(Error('Image timed out'))},12000);
      image.onload=()=>{clearTimeout(timer);try{const value=dominantColor(image);try{sessionStorage.setItem(key,value)}catch{}resolve(value)}catch(error){reject(error)}};
      image.onerror=()=>{clearTimeout(timer);reject(Error('Image unavailable'))};image.src=url;
    }));
    return colors.get(url);
  }
  async function apply(swatch){
    try{const value=await sample(swatch.dataset.autoSwatch);if(swatch.isConnected){swatch.style.setProperty('--swatch',value);swatch.dataset.swatchSource='image'}}
    catch{swatch.dataset.swatchSource='fallback'}
  }
  const observer='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){observer.unobserve(entry.target);apply(entry.target)}}),{rootMargin:'160px'}):null;
  function init(root){
    const swatches=[...(root.querySelectorAll?.('[data-auto-swatch]')||[])];if(root.matches?.('[data-auto-swatch]'))swatches.push(root);
    swatches.forEach(swatch=>{if(seen.has(swatch))return;seen.add(swatch);observer?observer.observe(swatch):apply(swatch)});
  }
  init(document);
  new MutationObserver(records=>records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1)init(node)}))).observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
